__turbopack_context__.v({
  "headColumn": "u6y2Ta_headColumn",
  "headColumn__stack": "u6y2Ta_headColumn__stack",
});
